import { useEffect, useState } from "react";

let globalListeners = [];
let globalInterval = null;
let globalTick = 0;

function startGlobalTimer() {
  if (globalInterval) return;

  globalInterval = setInterval(() => {
    globalTick++;
    globalListeners.forEach(fn => fn(globalTick));
  }, 1000);
}

export function useGlobalTimer() {
  const [tick, setTick] = useState(globalTick);

  useEffect(() => {
    globalListeners.push(setTick);

    startGlobalTimer();

    return () => {
      globalListeners = globalListeners.filter(fn => fn !== setTick);

      if (globalListeners.length === 0) {
        clearInterval(globalInterval);
        globalInterval = null;
      }
    };
  }, []);

  return tick; // cambia cada 1 segundo
}
